import { IBranch } from '../model/branch';
import { useBranchService } from '../service/branch';

const resource = 'pricelists';

const useBranch = () => {
  const {
    getById,
    create,
    update,
    remove,
    ...restService
  } = useBranchService();

  function getBranchById(id: string) {
    return getById(id);
  }

  async function createBranch(formData: IBranch) {
    const response = await create(formData);
    return response;
  }

  async function updateBranch(id: string, data: IBranch) {
    const response = await update(id, data);
    return response;
  }

  async function deleteBranch(id: string, rowVersion: string) {
    const response = await remove(id, rowVersion);
    return response;
  }

  return {
    resource,
    getBranchById,
    createBranch,
    updateBranch,
    deleteBranch,
    ...restService,
  };
};

export default useBranch;
